import { Divider, Grid } from "@mui/material";
import TextField from "components/Common/TextField/TextField";
import { configurationsInputFields, ConfigurationsInputValues } from "../types";

// Styles
import ConfigurationsInputFieldsContainer from "./ConfigurationsInputFields.styles";
import { areNumbersEqual } from "utils/number.utils";
import { useCallback } from "react";

interface ConfigurationsInputFieldsProps {
    handleChange: (value: number, name: string) => void;
    newConfigurationsValues: any;
    currentConfigurationsValues?: ConfigurationsInputValues | null;
    disabled?: boolean;
}

const ConfigurationsInputFields = ({
    disabled,
    handleChange,
    newConfigurationsValues,
    currentConfigurationsValues,
}: ConfigurationsInputFieldsProps) => {
    const isHighlighted = useCallback(
        (name: keyof ConfigurationsInputValues) => {
            if (currentConfigurationsValues) {
                return !areNumbersEqual(currentConfigurationsValues[name], newConfigurationsValues[name]);
            }
            return false;
        },
        [currentConfigurationsValues, newConfigurationsValues]
    );

    return (
        <ConfigurationsInputFieldsContainer>
            <>
                <p className={"inputTitle"}>CONFIGURATIONS</p>
                <Divider style={{ marginBottom: "15px" }} />
                <Grid
                    container
                    direction="row"
                    spacing={{ xs: 2, md: 2 }}
                    columns={{ xs: 4, sm: 8, md: 12 }}
                >
                    {configurationsInputFields.configurations.map((input) => {
                        if (input.type === "input") {
                            return (
                                <Grid
                                    key={input.name}
                                    item
                                    xs={2}
                                    sm={4}
                                    md={4}
                                >
                                    <label>{input.label}</label>
                                    <div className="textFieldDiv">
                                        <TextField
                                            placeholder={
                                                newConfigurationsValues[
                                                input.name as keyof ConfigurationsInputValues
                                                ]
                                            }
                                            type={"formattedValue"}
                                            change={(e: number) =>
                                                handleChange(e, input.name)
                                            }
                                            value={
                                                newConfigurationsValues[
                                                input.name as keyof ConfigurationsInputValues
                                                ]
                                            }
                                            disabled={disabled}
                                            isHighlighted={isHighlighted(input.name as keyof ConfigurationsInputValues)}
                                        />
                                    </div>
                                </Grid>
                            );
                        }
                    })}
                </Grid>

                <p className={"inputTitle"}>DUBLIN FEE SHEET</p>
                <Divider style={{ marginBottom: "15px" }} />
                <Grid
                    container
                    direction="row"
                    spacing={{ xs: 2, md: 2 }}
                    columns={{ xs: 4, sm: 8, md: 12 }}
                >
                    {configurationsInputFields.dublin_fee_sheet.map((input) => {
                        if (input.type === "input") {
                            return (
                                <Grid
                                    key={input.name}
                                    item
                                    xs={2}
                                    sm={4}
                                    md={4}
                                >
                                    <label>{input.label}</label>
                                    <div className="textFieldDiv">
                                        <TextField
                                            placeholder={
                                                newConfigurationsValues[
                                                input.name as keyof ConfigurationsInputValues
                                                ]
                                            }
                                            type={"formattedValue"}
                                            change={(e: number) =>
                                                handleChange(e, input.name)
                                            }
                                            value={
                                                newConfigurationsValues[
                                                input.name as keyof ConfigurationsInputValues
                                                ]
                                            }
                                            isHighlighted={isHighlighted(input.name as keyof ConfigurationsInputValues)}
                                        />
                                    </div>
                                </Grid>
                            );
                        }
                    })}
                </Grid>

                <p className={"inputTitle"}>DAILY PRICE RECONCILIATION</p>
                <Divider style={{ marginBottom: "15px" }} />
                <Grid
                    container
                    direction="row"
                    spacing={{ xs: 2, md: 2 }}
                    columns={{ xs: 4, sm: 8, md: 12 }}
                >
                    {configurationsInputFields.price_reconciliation.map((input) => {
                        if (input.type === "input") {
                            return (
                                <Grid
                                    key={input.name}
                                    item
                                    xs={2}
                                    sm={4}
                                    md={4}
                                >
                                    <label>{input.label}</label>
                                    <div className="textFieldDiv">
                                        <TextField
                                            placeholder={
                                                newConfigurationsValues[
                                                input.name as keyof ConfigurationsInputValues
                                                ]
                                            }
                                            type={"formattedValue"}
                                            change={(e: number) =>
                                                handleChange(e, input.name)
                                            }
                                            value={
                                                newConfigurationsValues[
                                                input.name as keyof ConfigurationsInputValues
                                                ]
                                            }
                                            disabled={disabled}
                                            isHighlighted={isHighlighted(input.name as keyof ConfigurationsInputValues)}
                                        />
                                    </div>
                                </Grid>
                            );
                        }
                    })}
                </Grid>
            </>
        </ConfigurationsInputFieldsContainer>
    );
};
export default ConfigurationsInputFields;
